<div class="top-nav d-flex justify-content-between align-items-center px-3 py-2">
  <!-- Left: Hamburger + Logo -->
  <div class="d-flex align-items-center gap-2">
    <button
      *ngIf="isMobile"
      class="sidebar-toggle p-0 border-0 bg-transparent"
      (click)="toggleSidebar.emit()"
      aria-label="Toggle sidebar">
      <i class="bi bi-list fs-4 text-white"></i>
    </button>

    <div class="d-flex align-items-center gap-2">
      <img class="company-logo" src="/logo/komudu.png" alt="Company Logo">
    </div>
  </div>

  <!-- Right: Availability -->
<div class="d-flex align-items-center gap-2" *ngIf="!IsRecruiter">
 
  <a *ngIf="!showAvailabilityPrompt; else availabilityPrompt"
     class="availability-link d-flex align-items-center gap-2"
     role="button"
     (click)="goToAvailability()"
     [attr.title]="availabilityTooltip"
     aria-label="Availability">
    <app-availability-gauge
      [updatedAt]="availabilityUpdatedAt"
      [size]="isMobile ? 44 : 60"         
      [greenMax]="7"
      [yellowMax]="14"
      [showTooltip]="false"
      imageBasePath="/images/gauges"
      imgGreen="gauge_green.png"
      imgYellow="gauge_yellow.png"
      imgRed="gauge_red.png">
    </app-availability-gauge>
    <span class="d-none d-md-inline fw-semibold" style="color: #1b297a;">Availability</span>
  </a>

  <!-- Prompt when missing/error -->
  <ng-template #availabilityPrompt>
    <span class="availability-prompt"
          role="button"
          (click)="goToAvailability()"
          [attr.title]="'Go to Availability'">
      Set your availability to let others know your current status.
    </span>
  </ng-template>
</div>

</div>
